import { NgModule } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BaseModule } from '../../shared/base.module';
import { SuicidalityComponent } from './suicidality.component';
import { MATERIALS } from '../../app.materials';
import { TinymceModule } from 'angular2-tinymce';


@NgModule({
    imports: [
        MATERIALS,
        BaseModule,
        TooltipModule.forRoot(),
        TinymceModule.withConfig({
            menubar: false,
            elementpath: false,
            toolbar: 'bold'
        }),
    ],
    exports: [SuicidalityComponent],
    declarations: [SuicidalityComponent],
    providers: [
        // {
        //     provide: 'TINYMCE_CONFIG', useValue: tinymceConfig
        // }
    ],
})

export class SuicidalityModule {
}
